import type { VideoCollection } from 'pkg/api/models/video_collection';

export function isNew(collection: VideoCollection): boolean {
	return collection.createdAt + 3600 * 24 > Math.floor(Date.now() / 1000);
}
